import {LOCAL_STORAGE_COMMENT_COOLDOWN} from '../constant';

export function getCommentCooldownLocalStorage(): {
  uid: string;
  expires: string;
} {
  const cooldownObjStr = window.localStorage.getItem(
    LOCAL_STORAGE_COMMENT_COOLDOWN
  );
  return cooldownObjStr ? JSON.parse(cooldownObjStr) : {uid: '', expires: ''};
}
